import script from "./DiaTierraView.vue?vue&type=script&setup=true&lang=js"
export * from "./DiaTierraView.vue?vue&type=script&setup=true&lang=js"

import "./DiaTierraView.vue?vue&type=style&index=0&id=19512645&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19512645"]])

export default __exports__